import { object, string } from 'yup'

export const validationLogin = (t) =>
  object({
    email: string()
      .email(t('login.error.email_format'))
      .required(t('login.error.required'))
      .transform((value) => value?.toLowerCase().trim()),
    password: string().required(t('login.error.required')),
  })
